import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=58770f74&scoped=true&"
import script from "./contracts.vue?vue&type=script&lang=js&"
export * from "./contracts.vue?vue&type=script&lang=js&"
import style0 from "./contracts.vue?vue&type=style&index=0&id=58770f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58770f74",
  null
  
)

export default component.exports